<template>
  <div class="content">
    <p class="ttile">
      魔方<span
        >(说明:魔方属于可自定义功能，您既可以展示商品，也可以展示活动海报。同时能在海报或者图片上，设置链接到页面地址。)
      </span>
    </p>
    <div class="set-content">
      <div class="set-item">
        <p class="title">选择类型</p>
        <TypeGroup v-model="curComponent.type" :options="typeOptions" />
        <div class="select-view">
          <span>选择模板</span>
          <span>{{ templateText }}</span>
        </div>
      </div>

      <div class="set-item add-img">
        <p class="title">添加图片</p>
        <p class="dec">图片支持.jpg、.gif、png，最多1张，单个图片不超过10M。</p>

        <UploadImgList
          v-model="imgs"
          :maxLength="typeCount"
          :haveImg="true"
          :haveTitle="false"
          jumpType="url"
          addBtnText="添加图片"
          :templateParams="{
            path: '',
            imgUrl: ''
          }"
        />
      </div>

      <div class="set-item basic-set">
        <p class="title">样式基础设置</p>
        <SpPickerColor
          v-if="haveBackgroundColorField"
          v-model="curComponent.backgroundColor"
          :isGradient="true"
          defaultColor="rgba(255,255,255,0)"
          label="背景颜色"
        />
        <SpSlider
          v-if="haveRadiusField"
          v-model="curComponent.radius"
          label="图片圆角值"
        />
        <SpSlider v-model="curComponent.imgMx" label="图片间隙" />
        <SpSlider v-model="curComponent.pageMx" label="页面间距" />
        <SpSlider v-model="curComponent.mb" label="页面底部间距" />
      </div>
    </div>
  </div>
</template>

<script>
import TypeGroup from "./components/TypeGroup";
import SpSlider from "../../../components/SpSlider";
import TypeViewGroup from "./components/TypeViewGroup";
import UploadImgList from "../../../components/UploadImgList";
import SpPickerColor from "../../../components/SpPickerColor";

import typeOptions from "./typeOptions";
export default {
  components: {
    TypeGroup,
    SpSlider,
    SpPickerColor,
    TypeViewGroup,
    UploadImgList
  },
  inject: ["control"],
  data() {
    return {
      typeOptions: Object.freeze(typeOptions)
    };
  },
  computed: {
    imgs: {
      get() {
        const imgs = this.control.curComponent.imgs;
        // 兼容以前对象数据结构
        if (!Array.isArray(imgs)) {
          const params = [];
          Object.keys(imgs).forEach(key => {
            if (params.length >= this.typeCount) return;
            if (imgs[key].imgUrl) params.push(imgs[key]);
          });
          this.control.curComponent.imgs = params;
        }

        return this.control.curComponent.imgs;
      },
      set(val) {
        this.control.curComponent.imgs = val;
      }
    },
    curComponent() {
      return this.control.curComponent;
    },
    templateText() {
      const title = this.typeOptions.find(
        item => item.type === this.curComponent.type
      ).title;
      return title;
    },
    typeCount() {
      const count = this.typeOptions.find(
        item => item.type === this.curComponent.type
      ).count;
      this.curComponent.count = count;
      return count;
    },
    haveRadiusField() {
      const flag = "radius" in this.curComponent;
      if (!flag) {
        this.$set(this.control.curComponent, "radius", 0);
      }
      return "radius" in this.curComponent;
    },
    haveBackgroundColorField() {
      const flag = "backgroundColor" in this.curComponent;
      if (!flag) {
        this.$set(
          this.control.curComponent,
          "backgroundColor",
          "rgba(255,255,255,0)"
        );
      }
      return "backgroundColor" in this.curComponent;
    }
  }
};
</script>

<style lang="less" scoped>
.content {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }
    > .add-img {
      margin-top: 30px;
    }

    > .basic-set {
      margin-top: 30px;
      /deep/ .slider-content,
      .picker-color {
        margin-bottom: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/Cube/Attr.vue